// extracted by mini-css-extract-plugin
export default {"homeSectionDivider":"Divider_homeSectionDivider__zIgZk","line":"Divider_line__ULJkm"};